import React from 'react';

/**
 * 데이트 픽커를 여는 트리거 버튼 컴포넌트.
 */
const DatePickerTrigger = ({ value, placeholder, isOpen, onClick }) => {
    return (
        <button
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            className={`flex items-center gap-2 cursor-pointer transition-all duration-200 group py-1 px-2 rounded-lg border-0 bg-transparent ${isOpen ? 'bg-blue-50/50' : 'hover:bg-gray-50'}`}
        >
            <span className={`text-[11px] sm:text-xs font-black tracking-tight transition-colors ${value ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'}`}>
                {value || placeholder}
            </span>
        </button>
    );
};

export default DatePickerTrigger;
